var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"citation_box"},[_c('LEFTNAV'),_c('div',{staticClass:"box",style:({ minHeight: _vm.Height + 'px' })},[_c('div',{staticClass:"box_part",style:({ minHeight: _vm.Height - 40 + 'px' })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }